<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h3 class="grey--text">Verval Dokumen</h3>
            <h2 class="info--text">Surat Pernyataan Komitmen Fasilitator</h2>
            <p class="body-2">
              Modul ini digunakan untuk melakukan <strong>Verval Ajuan Berkas Surat Pertanyaan Komitmen</strong> Calon
              Fasilitator
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <statistik :value="statistik"></statistik>
    <!--daftar-->
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          btn-filter
          btn-download
          @download="onDownloadList"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text"> Daftar Berkas Peserta yang perlu diperiksa</div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col class="py-0" cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-clipboard-plus-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 my-3">
                          <div class="info--text subtitle-2 mb-0">
                            <strong>
                              {{ $getDeepObj(item, 'ptk.data.nama') || '-' }}
                            </strong>
                          </div>
                          <div class="caption mb-0" style="line-height: 1rem">
                            <span class="grey--text">Unsur: </span>
                            {{ $getDeepObj(item, 'm_unsur_psp.data.keterangan') || '-' }}
                            <template v-if="$isObject(lockedAkun(item))">
                              <br />
                              <span class="grey--text">Verifikator: </span>
                              <span class="orange--text">{{ $getDeepObj(lockedAkun(item), 'data.nama') || '-' }}</span>
                            </template>
                            <template v-if="Number(item && item.is_cadangan) > -1">
                              <br />
                              <span class="caption grey--text">Status Cadangan: </span>
                              <span class="warning--text">{{
                                Number(item && item.is_cadangan) === 1
                                  ? 'Akselerasi 1'
                                  : Number(item && item.is_cadangan) === 2
                                  ? 'Akselerasi 2'
                                  : Number(item && item.is_cadangan) === 3
                                  ? 'Akselerasi 3'
                                  : 'Reguler'
                              }}</span>
                            </template>
                            <template>
                              <br />
                              <span class="caption grey--text">Status SMWW: </span>
                              <div>
                                <v-chip class="ml-1" small :color="statustNilai(item)['color']" dark>
                                  {{ statustNilai(item)['text'] }}
                                </v-chip>
                                <template v-if="isTerkendala(item)">
                                  <div :class="`${statusSusulan(item)['color']}--text caption mt-1`">
                                    <v-icon :color="`${statusSusulan(item)['color']}`" small style="top: -2px"
                                      >mdi-alert-circle</v-icon
                                    >
                                    {{ statusSusulan(item)['text'] }}
                                  </div>
                                </template>
                              </div>
                            </template>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption mb-0">Waktu Pengajuan</span>
                          <template v-for="(proses, key) in item.psp_profil_proseses.data || []">
                            <p class="ma-0 py-1" :key="key" v-if="Number(proses.k_profil_proses_psp) === 21">
                              <span>{{ $localDate(proses.wkt_proses || '', false, true) || '-' }}</span>
                            </p>
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <div><span class="caption mb-0">Status</span></div>
                          <div v-if="item.gelombang_susul">
                            <div>
                              <v-chip color="purple" dark small>
                                Ganti Peserta
                              </v-chip>
                            </div>
                          </div>
                          <div v-else>
                            <v-chip :color="COLOR[item.k_verval_mundur] || 'grey'" dark small>
                              {{ $getDeepObj(item, 'm_verval_psp_mundur.data.keterangan') || '-' }}
                            </v-chip>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 my-3">
                          <div><span class="caption">Aksi Selanjutnya</span></div>
                          <v-btn
                            color="primary"
                            small
                            block
                            @click="onKunci(item)"
                            v-if="
                              $allow(
                                `psp-${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas-mundur.kunci`,
                                item.policies
                              )
                            "
                          >
                            KUNCI BERKAS
                          </v-btn>
                          <v-btn
                            v-else-if="isAllowAkses(item.policies)"
                            color="primary"
                            small
                            block
                            @click="onVerval(item)"
                          >
                            {{ isAllowAkses(item.policies) ? 'PERIKSA' : 'LIHAT DETIL' }}
                          </v-btn>
                          <v-btn v-else color="success" outlined dark small block @click="onVerval(item)">
                            LIHAT DETIL
                          </v-btn>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="actions[jenis]" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      :title="formulir['title']"
      :autoClose="formulir['autoClose']"
      :useSave="formulir['is_edit']"
      @close="onClose"
      @save="onVervalSave"
    >
      <form-berkas
        ref="formulir"
        :masters="Object.assign({}, masters, { alasan_verval: formulir['alasan_verval'] || {} })"
        :id="formulir['id']"
        :detail="formulir['detail']"
        :berkas="formulir['berkas']"
        :fungsi="formulir['fungsi']"
        :angkatan="Number(params.angkatan) > 1 ? 2 : 1"
        :statistik="formulir['statistik']"
        :isEdit="formulir['is_edit']"
        :isDisable="formulir['is_disable']"
        :initValue="formulir['init']"
        :jenis="jenis"
        jenis-berkas="berkas-mundur"
      ></form-berkas>
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import Statistik from '../component/Statistik.Sehat';
import actions from './actions';
import FormBerkas from '../formulir/Berkas';
import { isArray, isObject } from '@utils/format';

export default {
  name: 'Index',
  components: { FormBerkas, Statistik },
  mixins: [list],
  data() {
    return {
      actions: actions,
      jenis: '',
      formulir: {},
      listTimVerval: [],
      COLOR: {
        2: 'orange',
        3: 'blue',
        4: 'red',
        5: 'red',
        6: 'green',
      },
      listLaporan: [
        {
          key: 'download',
          label: `Laporan Verval Berkas Surat Pernyataan Komitmen`,
        },
      ],
      tolak_komitmen: ['Kandidat diskualifikasi SMWW'],
      alasan_verval: [
        'Surat tidak lengkapi dengan materai',
        'Tidak ada tanda tangan',
        'Isian surat tidak lengkap',
        'Tanda tangan tempelan/ tidak asli',
      ],
      alasan_perbaikan_komitmen: [
        'Isian data diri pada Surat Komitmen belum lengkap.Mohon melengkapi data isian data diri dan mengunggah kembali sebelum 12 Desember 2021 sebelum pukul 21.00 WIB',
        'Surat Komitmen belum dibubuhi materai 10.000 atau 9.000 (atau 2 materai 6.000).Mohon melengkapi Surat Komitmen dengan materai 10.000 atau 9.000 (2 materai 6.000) dan mengunggah kembali sebelum 12 Desember 2021 sebelum pukul 21.00 WIB',
        'Materai pada surat komitmen terindikasi tidak asli, mohon membubuhkan materai asli dan mengunggah kembali sebelum 12 Desember 2021 sebelum pukul 21.00 WIB.',
        'Surat Komitmen tidak ada tanda tangan basah. Mohon melengkapi Surat Komitmen dengan tanda tangan basah dan mengunggah kembali sebelum 12 Desember 2021 sebelum pukul 21.00 WIB',
        'Surat Komitmen tidak sesuai dengan template yang telah disediakan. Mohon disesuaikan dengan template Surat Komitmen dan mengunggah kembali sebelum 12 Desember 2021 sebelum pukul 21.00 WIB',
      ],
      mCadangan: {
        '0': 'Reguler',
        '1': 'Akselerasi 1',
        '2': 'Akselerasi 2',
        '3': 'Akselerasi 3',
      },
      statusSmww: {
        '3': 'Belum Dinilai',
        '5': 'Sudah Dinilai',
        '6': 'Sudah Dikonfirmasi',
        '0': 'Terkendala( Diskualifikasi )',
        '1': 'Terkendala( Penjadwalan Kembali )',
      },
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      akun: (state) => (state.data && state.data.akun) || {},
    }),

    ...mapState('microteaching', {
      configSlot: (state) => Object.assign({}, state.configs) || {},
    }),

    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 12 }, { cols: 12 }],
        disabled: [],
      };
    },

    mapTimVerval() {
      let temp = {};
      for (const akun of this.listTimVerval) {
        temp[this.$getDeepObj(akun, 'akun.data.akun_id')] = this.$getDeepObj(akun, 'akun.data.nama');
      }
      return temp;
    },

    filtered() {
      const filters = this.filters;
      const master = this.filtersMaster;
      let label = [];
      for (let key in filters) {
        let value = filters[key];
        if (key === 'is_ulang') continue;

        if (key === 'is_kendala' && Number(value) === 1) {
          label.push(Number(filters.is_ulang) === 1 ? 'Penjadwalan Kembali' : 'Diskualifikasi');
        } else {
          if (value && typeof value === 'object' && (isObject(value) || isArray(value))) {
            for (let i = 0; i < value.length; i++) {
              let text = master[key] && master[key][value[i]];
              label.push({ text, key, value });
            }
          } else if (value && (value !== '' || value !== null)) {
            let text = (master[key] && master[key][value]) || '';
            label.push({ text, key, value });
          }
        }
      }
      return label;
    },

    formFilter() {
      let master = Object.assign({}, this.masters.verval_psp);
      // delete kandidat
      delete master[1];
      return [
        {
          label: 'Pilih Verifikator',
          model: 'akun_id',
          type: 'select',
          props: ['attach'],
          master: this.$mapForMaster(this.mapTimVerval),
          labelColor: 'secondary',
          grid: { cols: 12 },
        },
        {
          label: 'Pilih Status Verval',
          default: true,
          type: 'checkbox',
          model: 'k_verval_mundur',
          master: this.$mapForMaster(master),
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Pilih Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Status Cadangan',
          model: 'is_cadangan',
          type: 'select',
          props: ['attach'],
          master: this.$mapForMaster(this.mCadangan),
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Status SMWW',
          default: true,
          type: 'select',
          model: 'k_proses_simulasi_psp',
          props: ['attach'],
          master: [
            { value: '3', text: 'Belum Dinilai' },
            { value: '5', text: 'Sudah Dinilai' },
            { value: '6', text: 'Sudah Dikonfirmasi' },
            { value: '0', text: 'Terkendala( Diskualifikasi )' },
            { value: '1', text: 'Terkendala( Penjadwalan Kembali )' },
          ],
        },
      ];
    },

    filtersMaster() {
      return {
        k_verval_mundur: this.masters && this.masters['verval_psp'],
        k_propinsi: this.masters && this.masters['propinsi'],
        k_kota: this.masters && this.masters['kota'],
        k_unsur_psp: this.masters && this.masters['unsur_psp'],
        akun_id: this.mapTimVerval,
        is_cadangan: this.mCadangan,
        k_proses_simulasi_psp: this.statusSmww,
      };
    },
  },
  created() {
    this.jenis = this.$route.meta.jenis || 'kasek';
    this.getMasters('verval_psp;propinsi;kota;unsur_psp');
    this.getTimVerval({ jenis: this.jenis, berkas: 'berkas-mundur' }).then(({ data }) => {
      this.listTimVerval = data;
    });
  },
  methods: {
    ...mapActions('verval', ['fetch', 'action', 'getDetail', 'downloadList', 'getTimVerval']),
    ...mapActions('master', ['getMasters']),

    fetchData: function() {
      return new Promise((resolve) => {
        const berkas = 'mundur';
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const jenis = this.jenis;

        this.fetch({ params, berkas, jenis }).then(({ data, meta }) => {
          this.data = data || [];
          this.total = meta?.total || 0;
          this.pageTotal = meta?.last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          resolve(true);
        });
      });
    },

    filterSave(filters) {
      // Filter url rekaman
      let objFilter = Object.assign({}, filters);

      if (![undefined, '', null].includes(filters.k_proses_simulasi_psp)) {
        if (['0', '1'].includes(filters.k_proses_simulasi_psp)) {
          this.$set(objFilter, 'is_kendala', 1);
          this.$set(objFilter, 'is_ulang', filters.k_proses_simulasi_psp || 0);
          this.$delete(objFilter, 'k_proses_simulasi_psp');
        } else if (['3', '5', '6'].includes(filters.k_proses_simulasi_psp)) {
          this.$set(objFilter, 'is_kendala', 0);
          this.$set(objFilter, 'k_proses_simulasi_psp', filters.k_proses_simulasi_psp);
          this.$delete(objFilter, 'is_ulang');
        } else {
          this.$delete(objFilter, 'is_kendala', 1);
          this.$delete(objFilter, 'is_ulang');
          this.$delete(objFilter, 'k_proses_simulasi_psp');
        }
      }

      // set filter
      this.filters = objFilter;
      Object.assign(this.params, { page: 1 });
      this.fetchData().then(() => {
        this.$refs.filter.close();
      });
    },

    statustNilai(item) {
      const isKonfirmasi = Number(item.k_proses_simulasi_psp) === 6;
      const isLengkap = Number(item.k_proses_simulasi_psp) >= 5;
      const isTerkendala = this.isTerkendala(item);
      const status = {
        color: isTerkendala ? 'orange' : isLengkap && isKonfirmasi ? 'success' : 'grey',
        text: isTerkendala ? 'Terkendala' : isLengkap && isKonfirmasi ? 'Sudah' : 'Belum',
      };

      return status;
    },

    isTerkendala(item) {
      return !!item.kendala_penilai;
    },

    statusSusulan(item) {
      const pspSimulasi = this.$getDeepObj(item, 'psp_simulasis.data.0') || {};
      const susulan = pspSimulasi?.is_ulang ?? 0;
      return {
        color: susulan === 1 ? 'orange' : 'red',
        text: susulan === 1 ? 'Penjadwalan Kembali' : 'Diskualifikasi',
      };
    },

    onClose() {
      if (!this.formulir['autoClose']) {
        const msg = [
          '<h3>Apakah Anda yakin ingin keluar dari halaman Verifikasi Berkas Peserta ?</h3>',
          'data yang tidak disimpan akan hilang jika Anda keluar dari Halaman ini',
        ].join(' ');
        this.$confirm(msg, 'Peringatan', { tipe: 'error', lblConfirmColor: 'red', lblCancelColor: 'grey' }).then(() => {
          this.$refs.modal.dialog = false;
        });
      }
    },

    lockedAkun(item) {
      const proses = this.$getDeepObj(item, 'psp_profil_proseses.data') || [];
      const akun = this.$getDeepObj(proses.filter((item) => item.k_profil_proses_psp === 22)[0], 'akun');
      return akun || {};
    },

    isAjuanRevisi(item) {
      const proses = this.$getDeepObj(item, 'psp_profil_proseses.data') || [];
      const isRevisi = proses.findIndex((s) => Number(s.k_profil_proses_psp) === 8) > -1;
      const isAjuan = [2, 3].indexOf(Number(item.k_verval_sehat)) > -1;
      return isAjuan && isRevisi;
    },

    isAllowAkses(policies) {
      let enable = false;
      let akses = [
        `psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas-mundur.setuju`,
        `psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas-mundur.tolak-revisi`,
        `psp-${this.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}-berkas-mundur.tolak`,
      ];

      akses.forEach((key) => {
        if (!enable && this.$allow(key, policies)) {
          enable = true;
        }
      });

      return enable;
    },

    onKunci(data) {
      this.$confirm(`Anda yakin ingin mengunci Ajuan di atas agar bisa diverifikasi?`, `Kunci Ajuan`, {
        tipe: 'warning',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({
          id: data.psp_profil_id,
          jenis: this.jenis,
          type: 'kunci',
          berkas: 'mundur',
        }).then(() => {
          this.$success(`Ajuan Peserta berhasil dikunci`);
          this.onReload();
        });
      });
    },

    onBatalKunci(data) {
      this.$confirm(`Anda yakin ingin membatalkan Kunci Verifikasi Ajuan Peserta di atas?`, `Batal Kunci Ajuan`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({
          id: data.psp_profil_id,
          jenis: this.jenis,
          type: 'batal-kunci',
          berkas: 'mundur',
        }).then(() => {
          this.$success(`Batal kunci Ajuan Peserta berhasil`);
          this.onReload();
        });
      });
    },

    async onVerval(item) {
      const kVerval = Number(item['k_verval_mundur']);
      const status = {
        color: this.COLOR[kVerval],
        keterangan: this.$getDeepObj(item, `m_verval_psp_mundur.data.keterangan`) || '-',
      };

      let init = {};
      let statistik = this.statistik;

      init = {
        pilihan: kVerval === 3 ? null : kVerval === 4 ? 1 : kVerval === 6 ? 2 : 3,
      };

      this.$set(this.formulir, 'form', 'form-berkas');
      this.$set(this.formulir, 'title', 'Pemeriksaan Berkas Surat Pernyataan Komitmen');
      this.$set(this.formulir, 'id', item.psp_profil_id);
      this.$set(this.formulir, 'statistik', statistik);
      this.$set(this.formulir, 'init', null);

      this.getDetail({
        id: item.psp_profil_id,
        jenis: this.jenis,
        berkas: 'mundur',
      }).then(({ data }) => {
        const prosesAjuan = this.$getDeepObj(data, 'psp_profil_proseses.data').filter(
          (item) => item.k_profil_proses_psp === 8
        )[0];

        this.$set(this.formulir, 'alasan_verval', {
          perbaikan_komitmen: this.alasan_perbaikan_komitmen,
          tolak_komitmen: this.tolak_komitmen,
        });
        this.$set(this.formulir, 'is_disable', !this.isAllowAkses(data.policies));
        this.$set(this.formulir, 'is_edit', this.isAllowAkses(data.policies));
        this.$set(this.formulir, 'autoClose', !this.isAllowAkses(data.policies));

        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
          this.$set(this.formulir, 'init', init);
          this.$set(this.formulir, 'detail', data);
          this.$set(this.formulir, 'berkas', this.$getDeepObj(data, 'psp_profil_berkases.data'));
          this.$set(this.formulir.detail, 'status', status);
          this.$set(this.formulir.detail, 'alasan', (prosesAjuan && prosesAjuan.catatan) || '');
          this.$set(this.formulir.detail, 'verifikator', this.lockedAkun(item));
        });
      });
    },

    onVervalSave() {
      const formulir = Object.assign({}, this.$refs.formulir.getValue());
      const status = formulir.pilihan;
      const alasan = formulir.alasan;
      const id = formulir.id;
      if (status) {
        const aksi = status === 1 ? 'tolak' : status === 2 ? 'setuju' : 'tolak-revisi';
        const html = `<span class="subtitle-1">Anda Yakin ingin <strong>${
          status === 1 ? 'menolak' : status === 2 ? 'menerima' : 'menyatakan perbaikan'
        }</strong> ajuan verval berikut ?</span>`;

        this.$confirm(html, 'Konfirmasi', { tipe: status === 1 ? 'error' : status === 2 ? 'success' : 'warning' }).then(
          () => {
            this.$refs.modal.loading = true;
            this.action({
              id: id,
              type: aksi,
              jenis: this.jenis,
              berkas: 'mundur',
              params: { alasan: JSON.stringify(alasan) },
            })
              .then(() => {
                this.$success('Data ajuan berhasil di ubah');
                this.$refs.modal.dialog = false;
                this.onReload();
              })
              .catch(() => {
                this.$refs.modal.loading = false;
              });
          }
        );
        this.$refs.modal.loading = false;
      } else {
        this.$error('Silakan tentukan hasil verifikasi data sebelum simpan');
        this.$refs.modal.loading = false;
      }
    },

    onBatalVerval(data) {
      this.$confirm(`Anda yakin ingin membatalkan VerVal Ajuan di atas?`, `Batal Verval`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({
          id: data.psp_profil_id,
          jenis: this.jenis,
          type: 'batal-verval',
          berkas: 'mundur',
        }).then(() => {
          this.$success(`Batal Verval Ajuan Peserta berhasil`);
          this.onReload();
        });
      });
    },

    downloadLaporan(url) {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
      const berkas = 'mundur';

      this.downloadList({ params, berkas, url: url.dokumen }).then((url) => {
        this.$downloadFile(url);
      });
    },

    confirmHtml(data) {
      return [
        {
          icon: 'mdi-account-circle',
          iconSize: 60,
          iconColor: 'secondary',
          title: this.$getDeepObj(data, 'ptk.data.nama') || '',
          subtitles: [
            `<span class="text--primary">${this.$getDeepObj(data, 'ptk.data.no_ukg') ||
              this.$getDeepObj(data, 'ptk.data.email')}</span>`,
          ],
        },
      ];
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
